import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=40b96466&"
import script from "./reportList.vue?vue&type=script&lang=js&"
export * from "./reportList.vue?vue&type=script&lang=js&"
import style0 from "./reportList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports